import OrderPaymentCommonComponent from "./OrderPaymentCommonComponent";

export default function OrderPaymentFormComponent({ context, order, onPaymentParentActionHandler, defaultDiscountTypes }) {
  return (
    <div className="w-[650px] p-4 rounded shadow">
      <OrderPaymentCommonComponent 
        order={order}
        shouldShowCookingTime={false}
        setShouldResetData={() => {}}
        onPaymentParentActionHandler={onPaymentParentActionHandler}
        defaultDiscountTypes={defaultDiscountTypes}
      />
    </div>
  );
}
